import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';
import { AclPermissionModule } from '@y42/acl/shared/permission';
import { Y42AgGridModule } from '@y42/ag-grid';
import { IconModule } from '@y42/core/icon';
import { MatTooltipTruncateModule } from '@y42/core/mat-tooltip-truncate';
import { IntercomModule } from '@y42/intercom';
import { AngularSplitModule } from 'angular-split';
import { ListViewAddEditQuickFilterDialogComponent } from './list-view-add-edit-quick-filter-dialog/list-view-add-edit-quick-filter-dialog.component';
import { ListViewGridComponent } from './list-view-grid/list-view-grid.component';
import { ListViewQuickFilterComponent } from './list-view-quick-filter/list-view-quick-filter.component';
import { ListViewQuickFiltersComponent } from './list-view-quick-filters/list-view-quick-filters.component';
import { ListViewSearchFieldComponent } from './list-view-search-field/list-view-search-field.component';
import { ListViewComponent } from './list-view.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,

    MatSidenavModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatButtonModule,
    MatProgressBarModule,
    MatMenuModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,

    Y42AgGridModule,
    FontAwesomeModule,
    IconModule,
    MtxPopoverModule,
    IntercomModule,
    AngularSplitModule,
    MatTooltipTruncateModule,
    AclPermissionModule,
  ],
  declarations: [
    ListViewComponent,
    ListViewSearchFieldComponent,
    ListViewGridComponent,
    ListViewQuickFiltersComponent,
    ListViewQuickFilterComponent,
    ListViewAddEditQuickFilterDialogComponent,
  ],
  exports: [ListViewComponent],
})
export class ListViewModule {}
